
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M38.6 20c0 10.3-8.3 18.6-18.6 18.6S1.4 30.3 1.4 20 9.7 1.4 20 1.4 38.6 9.8 38.6 20z","fill":"none","stroke":"#ffa635","stroke-dasharray":"3,2"}}),_c('path',{attrs:{"d":"M11.6 24.2c-1.4 0-1.9-.9-1-2l9.1-11.1c.4-.5 1.1-.5 1.5 0l8.7 11.1c.9 1.1.5 2.1-1 2.1H11.6z","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#ffa635"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/home/tabs/network/DropClosure.svg